import { Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoute from "./admin/ProtectedRoute";
import useAuth from "./hooks/useAuth";
import AdminLayout from "./templates/AdminLayout";
import UserLayout from "./templates/UserLayout";
import CategoryListPage from "./admin/pages/categories/CategoryListPage";
import CategoryCreatePage from "./admin/pages/categories/CategoryCreatePage";
import CategoryDetailPage from "./admin/pages/categories/CategoryDetailPage";
import CategoryEditPage from "./admin/pages/categories/CategoryEditPage";
import LoginPage from "./admin/pages/LoginPage";
import SizeListPage from "./admin/pages/size/SizeListPage";
import SizeCreatePage from "./admin/pages/size/SizeCreatePage";
import SizeEditPage from "./admin/pages/size/SizeEditPage";
import CoverFabricListPage from "./admin/pages/cover-fabric/CoverFabricListPage";
import CoverFabricCreatePage from "./admin/pages/cover-fabric/CoverFabricCreatePage";
import CoverFabricEditPage from "./admin/pages/cover-fabric/CoverFabricEditPage";
import CoverDesignListPage from "./admin/pages/cover-design/CoverDesignListPage";
import CoverDesignCreatePage from "./admin/pages/cover-design/CoverDesignCreatePage";
import CoverDesignEditPage from "./admin/pages/cover-design/CoverDesignEditPage";

import ProductCreatePage from "./admin/pages/Product/ProductCreatePage";
import ProductListPage from "./admin/pages/Product/ProductListPage";
import ProductEditPage from "./admin/pages/Product/ProductEditPage";

import OrderListPage from "./admin/pages/orders/OrderListPage";
import OrderDetailPage from "./admin/pages/orders/OrderDetailPage";

import BannerListPage from "./admin/pages/banners/BannerListPage";
import BannerCreatePage from "./admin/pages/banners/BannerCreatePage";
import BannerEditPage from "./admin/pages/banners/BannerEditPage";

import AboutUsPage from "./admin/pages/AboutUsPage";

import FaqListPage from "./admin/pages/faqs/FaqListPage";
import FaqCreatePage from "./admin/pages/faqs/FaqCreatePage";
import FaqEditPage from "./admin/pages/faqs/FaqEditPage";

import SalesReportPage from "./admin/pages/report/SalesReportPage";


import HomePage from "./user/pages/HomePage";
import AboutPage from "./user/pages/AboutPage";
import ProductDetailPage from "./user/pages/ProductDetailPage";
import CheckoutPage from "./user/pages/CheckoutPage";
import BankAccountListPage from "./admin/pages/bank-accounts/BankAccountListPage";
import BankAccountCreatePage from "./admin/pages/bank-accounts/BankAccountCreatePage";
import BankAccountEditPage from "./admin/pages/bank-accounts/BankAccountEditPage";
import OrderUserListPage from "./user/pages/orders/OrderListPage";
import OrderUserDetailPage from "./user/pages/orders/OrderDetailPage";
import SettingPage from "./admin/pages/SettingPage";
import DashboardPage from "./admin/pages/dashboard/DashboardPage";
import SalesByCustomerPage from "./admin/pages/report/SalesByCustomerPage";
import SalesByProductPage from "./admin/pages/report/SalesByProductPage";

export default function AppRoutes() {
    const { user, loading } = useAuth();
    // const location = useLocation();

    console.log(user)

    if (loading) return <p>Loading...</p>;

    return (
        // <BrowserRouter>
        <Routes>
            <Route path="/admin/login" element={<LoginPage />} />

            <Route path="/admin/*" element={<AdminLayout />}>


                {/* Protected routes for admin */}
                {/* <Route path="categories" element={
            <ProtectedRoute user={user} requiredRole="admin">
              <CategoryPage />
            </ProtectedRoute>
          } /> */}

                <Route path="dashboard" element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <DashboardPage />
                        </ProtectedRoute>
                    } />

                <Route
                    path="categories"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <CategoryListPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="categories/create"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <CategoryCreatePage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="categories/:id"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <CategoryDetailPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="categories/:id/edit"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <CategoryEditPage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="sizes"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <SizeListPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="sizes/create"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <SizeCreatePage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="sizes/:id/edit"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <SizeEditPage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="cover-fabrics"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <CoverFabricListPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="cover-fabrics/create"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <CoverFabricCreatePage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="cover-fabrics/:id/edit"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <CoverFabricEditPage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="cover-designs"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <CoverDesignListPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="cover-designs/create"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <CoverDesignCreatePage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="cover-designs/:id/edit"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <CoverDesignEditPage />
                        </ProtectedRoute>
                    }
                />


                <Route
                    path="products/create"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <ProductCreatePage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="products"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <ProductListPage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="products/:id/edit"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <ProductEditPage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="bank-accounts"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <BankAccountListPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="bank-accounts/create"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <BankAccountCreatePage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="bank-accounts/:id/edit"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <BankAccountEditPage />
                        </ProtectedRoute>
                    }
                />


                <Route
                    path="orders"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <OrderListPage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="orders/:id"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <OrderDetailPage />
                        </ProtectedRoute>
                    }
                />



                <Route
                    path="banners"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <BannerListPage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="banners/create"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <BannerCreatePage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="banners/:id/edit"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <BannerEditPage />
                        </ProtectedRoute>
                    }
                />



                <Route
                    path="faqs"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <FaqListPage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="faqs/create"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <FaqCreatePage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="faqs/:id/edit"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <FaqEditPage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="about-us"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <AboutUsPage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="settings"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <SettingPage />
                        </ProtectedRoute>
                    }
                />


                <Route
                    path="report-sales"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <SalesReportPage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="report-sales-by-customer"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <SalesByCustomerPage />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="report-sales-by-product"
                    element={
                        <ProtectedRoute user={user} requiredRole="admin">
                            <SalesByProductPage />
                        </ProtectedRoute>
                    }
                />

            </Route>



            <Route path="/*" element={<UserLayout />}>
                {/* Route user di sini */}
                <Route index element={<HomePage />} />
                <Route path="product/:id" element={<ProductDetailPage />} />
                <Route path="checkout/:id" element={<CheckoutPage />} />
                <Route path="orders" element={<OrderUserListPage />} />
                <Route path="orders/:id" element={<OrderUserDetailPage />} />
                <Route path="about" element={<AboutPage />} />
            </Route>
        </Routes>
        // </BrowserRouter>
    );
}
